import { dexieDB } from "@/services/dexie-database";
import { LogLevel, LogService } from "@/services/logging";
import POSConfigModule from "@/store/modules/pos-config";
import { IPaginate } from "@/types/app";
import { IPromocodeCampaign } from "@/types/db/promocode-campaign";
import dayjs from "dayjs";

export async function savePromocodeCampaigns(
  promocodeCampaigns: IPromocodeCampaign[]
) {
  try {
    LogService.info(`Saving promocode campaigns into DexieDB`);
    await dexieDB.promocodeCampaigns.bulkAdd(promocodeCampaigns);
  } catch (error) {
    LogService.info(
      `Error when saving promocode campaigns into DexieDB`,
      {
        params: {
          error: error,
        },
      },
      LogLevel.Error
    );
  }
}

export async function getActivePromocodeCampaigns(options: {
  pinnedOnly?: boolean;
  pagination?: IPaginate;
  searchTerm?: string;
}) {
  const { pinnedOnly = false, pagination, searchTerm } = options;
  const configId = Number(POSConfigModule.selectedConfig?.id);
  const now = dayjs();

  let query = dexieDB.promocodeCampaigns
    .where({
      posConfigId: configId,
    })
    .and(
      (p) =>
        dayjs(p.startDateTime).isSameOrBefore(now) &&
        dayjs(p.endDateTime).isSameOrAfter(now)
    );

  if (pinnedOnly) {
    query = query.and((p) => p.isPinned);
  }
  if (searchTerm) {
    query = query.and((p) =>
      p.name.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())
    );
  }

  // First get the filtered results
  let results = await query.toArray();

  // Sort by position (0 comes first)
  results.sort((a, b) => {
    const posA = a.position ?? 25;
    const posB = b.position ?? 25;
    return posA - posB;
  });

  // Apply pagination after sorting if needed
  if (pagination) {
    const { skip, limit } = pagination;
    results = results.slice(skip, skip + limit);
  }

  return results;
}
